<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <i-btn
        class="btn-type-01 mr-2"
        v-bind="attrs"
        v-on="on"
        @click.stop="init"
        >{{ $t('비밀번호변경') }}</i-btn
      >
    </template>
    <v-card class="modal-pop modal-type-01">
      <v-card-title class="modal-title">
        {{ $t('비밀번호 변경') }}
      </v-card-title>
      <vue-custom-scrollbar class="modal-scroll">
        <v-form ref="form">
          <v-card-text class="modal-contents">
            <v-row class="ma-0">
              <v-col class="pa-0">
                <v-row class="ma-0 mb-2">
                  <i-text-field
                    :append-icon="show1 ? mdiEye : mdiEyeOff"
                    v-model="password"
                    :rules="[
                      rules.required,
                      rules.min,
                      rules.char,
                      rules.number,
                      rules.specialChar,
                    ]"
                    :type="show1 ? 'text' : 'password'"
                    label="기존 비밀번호"
                    @click:append="show1 = !show1"
                    dense
                    hide-details="auto"
                    outlined
                    class="box-type-01"
                  ></i-text-field>
                </v-row>
                <v-row class="ma-0 mb-2">
                  <i-text-field
                    :append-icon="show1 ? mdiEye : mdiEyeOff"
                    v-model="newPassword"
                    :rules="[
                      rules.required,
                      rules.min,
                      rules.char,
                      rules.number,
                      rules.specialChar,
                    ]"
                    :type="show2 ? 'text' : 'password'"
                    label="새로운 비밀번호"
                    @click:append="show2 = !show2"
                    dense
                    outlined
                    hide-details="auto"
                    class="box-type-01"
                  ></i-text-field>
                </v-row>
                <v-row class="ma-0">
                  <i-text-field
                    :append-icon="show1 ? mdiEye : mdiEyeOff"
                    v-model="confirmNewPassword"
                    :rules="[
                      rules.required,
                      rules.min,
                      rules.char,
                      rules.number,
                      rules.specialChar,
                      rules.passwordMatch,
                    ]"
                    :type="show3 ? 'text' : 'password'"
                    label="새로운 비밀번호 재입력"
                    @click:append="show3 = !show3"
                    dense
                    outlined
                    hide-details="auto"
                    class="box-type-01"
                  ></i-text-field>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </vue-custom-scrollbar>
      <v-card-actions class="modal-btn">
        <i-btn class="btn-type-01" @click="dialog = false">
          닫기
        </i-btn>
        <i-btn class="btn-type-02" @click="changePwd()">
          저장
        </i-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getJson, API } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';

import { mdiEye, mdiEyeOff } from '@mdi/js';

import RSAKey from '@/utils/rsa/rsa.js';

import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';

export default {
  components: { vueCustomScrollbar },
  mixins: [DialogMixin],
  data() {
    return {
      mdiEye,
      mdiEyeOff,
      email: '',
      password: '',
      newPassword: '',
      confirmNewPassword: '',
      dialog: false,
      show1: false,
      show2: false,
      show3: false,
      rules: {
        required: value => !!value || '필수항목입니다.',
        min: value =>
          value == null ||
          value.length >= 8 ||
          '최소 8글자는 입력하셔야 합니다.',
        char: v =>
          /(?=.*[a-zA-Z])/.test(v) || '최소 하나의 문자가 포함되어야 합니다.',
        number: v =>
          /(?=.*\d)/.test(v) || '최소 하나의 숫자가 포함되어야 합니다.',
        specialChar: v =>
          /([!@#$%])/.test(v) ||
          '최소 하나의 특수문자가 포함되어야 합니다. 예)!@#$%',
        passwordMatch: value =>
          value === this.newPassword || '변경할 비밀번호와 일치하지 않습니다.',
      },
    };
  },
  methods: {
    init() {
      this.email = this.$attrs.email;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    async changePwd() {
      if (this.$refs.form && this.$refs.form.validate()) {
        this.showLoading;
        const { data: pubRsaKey } = await getJson(
          '/api/v1/tenant/login/encryption',
          {},
        );

        const rsa = new RSAKey();
        rsa.setPublic(pubRsaKey.publicKeyModulus, pubRsaKey.publicKeyExponent);
        console.log('1');

        const p = {
          email: this.email,
          password: rsa.encrypt(this.password),
          newPassword: rsa.encrypt(this.newPassword),
          sessionKey: pubRsaKey.sessionKey,
        };

        API.postAuthJson('/change/pwd', p)
          .then(res => {
            console.log(res);
            if (res.data != null && res.data.hasOwnProperty('status')) {
              if (res.data.status === 'success') {
                this.$showAlert('비밀번호가 변경되었습니다.');
                // location.reload();
              } else {
                this.$showAlert(res.data.message);
              }
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
  },
};
</script>
